module.exports = __webpack_public_path__ + "static/img/6674_phase_function_Paper_PointsHejduk_Prediction.98969ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6674_phase_function_Paper_PointsHejduk_Prediction.png
// module id = STP5
// module chunks = 0